/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_A2Inputs */

const en_minifier_faq_a2 = /** @type {(inputs: Minifier_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Minification only removes whitespace. Your data values remain exactly the same.`)
};

const ko_minifier_faq_a2 = /** @type {(inputs: Minifier_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아닙니다. 압축은 공백만 제거합니다. 데이터 값은 그대로 유지됩니다.`)
};

const ja_minifier_faq_a2 = /** @type {(inputs: Minifier_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。圧縮は空白のみを削除します。データの値はそのまま維持されます。`)
};

/**
* | output |
* | --- |
* | "No. Minification only removes whitespace. Your data values remain exactly the same." |
*
* @param {Minifier_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_a2 = /** @type {((inputs?: Minifier_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_a2(inputs)
	if (locale === "ko") return ko_minifier_faq_a2(inputs)
	return ja_minifier_faq_a2(inputs)
});